/*This component is generated automatically by generateAssets.py. Do not edit it manually. 
The component getAsset() helps us to use our theme on the svgs and make importing easier.
To update please run `npm run generateAssets.ts`*/
import { colors } from "../../styles/colors";
import Calendar from "./Calendar.svg?react";
import Checkmark from "./Checkmark.svg?react";
import Clock from "./Clock.svg?react";
import Close from "./Close.svg?react";
import EyeClosed from "./EyeClosed.svg?react";
import EyeOpen from "./EyeOpen.svg?react";
import FailureIcon from "./FailureIcon.svg?react";
import Info from "./Info.svg?react";
import Logo from "./Logo.svg?react";

export type SVGName =
  | "Calendar"
  | "Checkmark"
  | "Clock"
  | "Close"
  | "EyeClosed"
  | "EyeOpen"
  | "FailureIcon"
  | "Info"
  | "Logo";

type SvgProps = {
  [key: string]: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
      primary?: string | undefined;
      secondary?: string | undefined;
    }
  >;
};
const svgs: SvgProps = {
  Calendar,
  Checkmark,
  Clock,
  Close,
  EyeClosed,
  EyeOpen,
  FailureIcon,
  Info,
  Logo,
};

type Props = React.SVGProps<SVGSVGElement> & {
  name: SVGName;
  primaryColor?: string;
  secondaryColor?: string;
  size?: number;
};
export const GenericSvg = (props: Props) => {
  const Icon = svgs[props.name as SVGName];
  const cleanedProps = { ...props };
  delete cleanedProps.primaryColor;
  delete cleanedProps.secondaryColor;
  delete cleanedProps.size;
  delete cleanedProps.height;
  return (
    <div>
      <Icon
        {...cleanedProps}
        primary={props.primaryColor ?? colors.primary}
        secondary={props.secondaryColor ?? colors.medium}
        height={props.size ?? props.height}
        width={props.size ?? props.width}
      />
    </div>
  );
};
